import React from "react";

const Videography = () => {
  return (
    <div className="videography">
      <div className="videography-header">
        <div className="Videography-heading">VIDEOGRAPHY</div>
        <p className="videography-head2">at Surya Vilas Palace</p>
        <img
          className="videography-img"
          src="/Assets/experience-logo.webp"
          alt="group615img"
        ></img>
      </div>

      <div className="videography-bg">
        <img
          className="videography-banglow"
          src="/Assets/videography-img.webp"
          alt="banglow"
        ></img>
        <div className="play">
          <div className="play-img-container">
            <img className="play-img" src="/Assets/play1.webp" alt="play"></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videography;
